<template lang="pug">
  div
    // Loading state
    template(v-if="isFetching")
      div(style="max-width: 1200px; margin: auto; padding: 40px;")
        claim-loading-state

    // Error state
    template(v-else-if="isError")
      div(style="max-width: 1200px; margin: auto; padding: 40px;")
        yz-empty-state-card(icon="$yzi-alert-triangle" :title="$t('panel.unable_to_load_invoice_details')" :description="$t('panel.invoice_info_could_not_be_retrieved')" border-color="yz-danger-500" icon-color="yz-danger-500" action-label="Try again" @action-click="fetchInvoices")

    // Content
    template(v-else)
      // Header
      single-claim-header(:parent-claim="parentClaim" @go-back="onGoBack" @updated="onClaimUpdated")

      // Content
      v-row.mt-6(no-gutters)
        // Left column - Summary and Patient Details
        v-col(cols="8")
          // Summary Section
          single-claim-summary-card(:parent-claim="parentClaim" :parent-invoice="invoice")

          // Documents Section
          claim-documents-card.mt-6(:parent-claim="parentClaim" :is-refreshing="isRefreshingDocuments" @updated="onDocumentUpdated")

          // Payments Section
          claim-payments-card.mt-6(:parent-claim="parentClaim" :is-refreshing="isRefreshingPayments" @updated="onPaymentUpdated")

          // Remarks Section
          claim-remarks-card.mt-6(:parent-claim="parentClaim")

        // Right column - Logs
        v-col.ml-3
          claim-logs-card(:parent-claim="parentClaim")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SingleClaimSummaryCard from '@/components/clinic/panel/claims/single/SingleClaimSummaryCard.vue'
import ClaimDocumentsCard from '@/components/clinic/panel/claims/overview/ClaimDocumentsCard.vue'
import ClaimPaymentsCard from '@/components/clinic/panel/claims/overview/ClaimPaymentsCard.vue'
import ClaimRemarksCard from '@/components/clinic/panel/claims/overview/ClaimRemarksCard.vue'
import ClaimLogsCard from '@/components/clinic/panel/claims/overview/ClaimLogsCard.vue'
import SingleClaimHeader from '@/components/clinic/panel/claims/single/SingleClaimHeader.vue'
import ClaimLoadingState from '@/components/clinic/panel/claims/ClaimLoadingState.vue'

export default {
  components: { SingleClaimSummaryCard, ClaimDocumentsCard, ClaimPaymentsCard, ClaimRemarksCard, ClaimLogsCard, SingleClaimHeader, ClaimLoadingState },
  props: {
    parentClaim: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFetching: false,
      isError: false,
      invoice: null,
      isRefreshingDocuments: false,
      isRefreshingPayments: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  watch: {
    parentClaim: {
      handler() {
        // Reset loading state when parent claim updates
        if (this.isRefreshingDocuments) {
          this.isRefreshingDocuments = false
        }
        if (this.isRefreshingPayments) {
          this.isRefreshingPayments = false
        }
      },
      deep: true
    }
  },
  mounted() {
    this.fetchInvoices()
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchInvoices() {
      if (!this.parentClaim.invoices?.length) {
        return
      }

      this.isFetching = true
      this.isError = false

      try {
        const invoiceUid = this.parentClaim.invoices[0]
        const { data } = await this.$axios.get(`/panels/${this.company.slug}/invoices/${invoiceUid}`)
        // Store fetched invoice
        this.invoice = data
      } catch (error) {
        console.error('Error fetching invoice details:', error)
        this.isError = true
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    onGoBack() {
      this.$emit('go-back')
    },
    onClaimUpdated() {
      this.$emit('updated', { showLoading: true })
    },
    onDocumentUpdated() {
      this.isRefreshingDocuments = true
      this.$emit('updated', 'documents')
    },
    onPaymentUpdated() {
      this.isRefreshingPayments = true
      this.$emit('updated', 'payments')
    }
  }
}
</script>

<style scoped></style>
